import { render, staticRenderFns } from "./WebPartPageDiv.vue?vue&type=template&id=18e7abe0"
import script from "./WebPartPageDiv.ts?vue&type=script&lang=ts&external"
export * from "./WebPartPageDiv.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports